<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12" class="pt-0">
      <v-row justify="space-between">
        <v-col cols="6">
          <h1>Блюда</h1>
        </v-col>
        <v-col cols="3" class="search-col">
          <v-text-field
                  v-model="search"
                  prepend-icon="mdi-magnify"
                  label="Поиск"
                  single-line
                  otlined
                  hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-tabs v-model="tab">
        <v-tab>Все</v-tab>
        <v-tab>Активные</v-tab>
        <v-tab>Скрытые</v-tab>
      </v-tabs>

      <v-row>
        <v-col cols="6" class="pb-2">
          <v-btn @click="$router.push({ name: 'product-sort'})" outlined>Сортировка блюд</v-btn>
        </v-col>
        <v-col cols="6" class="text-right pb-2">
          <v-btn @click="$router.push({ name: 'product-create'})">Создать</v-btn>
        </v-col>
        <v-col cols="12" sm="3" class="pt-2" style="min-height: 60px;">
          <template v-if="selected.length > 0">
          <v-btn class="mr-3" :disabled="selected.length === 0" outlined>Выбрано: {{ selected.length }}</v-btn>
          <v-menu offset-y left :disabled="selected.length === 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined
                     :disabled="selected.length === 0"
                     class="pl-0 pr-0"
                     min-width="36"
                     v-bind="attrs"
                     v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="massTagDialog = true">
                <v-list-item-title>Назначить тег</v-list-item-title>
              </v-list-item>
              <v-list-item @click="massHide" v-if="tab == 0 || tab == 1">
                <v-list-item-title>Скрыть блюда</v-list-item-title>
              </v-list-item>
              <v-list-item @click="massActive" v-if="tab == 0 || tab == 2">
                <v-list-item-title>В активные</v-list-item-title>
              </v-list-item>
              <v-list-item @click="submitDialog = true; submitItem = null">
                <v-list-item-title>Удалить</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          </template>
        </v-col>
        <v-col cols="12" sm="9" class="pt-2">
          <v-slide-group class="text-right">
            <v-spacer></v-spacer>
            <v-slide-item v-for="item in filters.category.value" :key="item.id">
              <v-chip
                      class="v-btn ml-3"
                      close
                      @click:close="removeCategory(item)"
                      color="#FAFCFF"
                      outlined
                      label
                      text-color="currentColor"
              >
                {{ getCategoryNameById(item) }}
              </v-chip>
            </v-slide-item>
            <v-slide-item v-for="item in filters.tag.value" :key="item.id">
              <v-chip
                      class="v-btn ml-3"
                      close
                      @click:close="removeTag(item)"
                      color="#FAFCFF"
                      outlined
                      label
                      text-color="currentColor"
              >
                {{ getTagNameById(item) }}
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>

      <v-data-table
              no-data-text="Нет блюд"
              no-results-text="По заданному запросу ничего не найдено"
              v-model="selected"
              :headers="headers"
              :items="products"
              :search="search"
              :fixed-header="true"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              height="60vh"
              :options.sync="options"
              :footer-props="footerProps"
              :server-items-length="totalProducts"
              :loading="loading"
              :item-class="getItemClass"
              :items-per-page="15"
              loading-text="Загрузка блюд... Подождите пожалуйста"
              show-select
      >
        <template v-slot:item.price="{ item, index }">
          {{ item.price }} UAH
        </template>
        <template v-slot:item.tag="{ item, index }">
          <span v-for="tag in item.tags">{{tag.name}}{{tag == item.tags[item.tags.length - 1] ? '' : ', ' }} </span>
        </template>
        <template v-slot:header.category.name>
          Категория<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.category.value.length > 0}"
                 @click.stop.prevent="filters.category.modal = !filters.category.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.name>
          Блюдо<br>
        </template>
        <template v-slot:header.tag>
          Теги<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.tag.value.length > 0}"
                 @click.stop.prevent="filters.tag.modal = !filters.tag.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:item.category.name="{ item }">
          <template v-if="item.category">
            {{ item.category.parent ? item.category.parent.name + ' -' : '' }} {{ item.category.name }}
          </template>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click.stop="$router.push({ name: 'product-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop="copy(item.id)">
                  <v-list-item-title>Копировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <v-dialog
            v-model="massTagDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title class="headline">
          Назначение тега
        </v-card-title>

        <v-card-text>
          <v-select
                  :items="tags"
                  :item-text="tag => tag.name"
                  :item-value="tag => tag.id"
                  v-model="massSelectedTag"
                  label="Выберите тег"
                  outlined
                  :hide-details="true"
          >
          </v-select>
        </v-card-text>

        <v-card-actions>
          <v-btn
                  @click="massTag(); massTagDialog = false">
            Назначить
          </v-btn>
          <v-btn
                  outlined
                  @click="massTagDialog = false"
          >
            Отменить
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="filters.category.modal"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
                  :items="categories"
                  :item-text="category => category.name"
                  :item-value="category => category.id"
                  v-model="filters.category.tempValue"
                  label="Категория"
                  :clearable="true"
                  outlined
                  multiple
                  :hide-details="true"
          >
            <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="font-weight-bold">
                    Выбрано: {{ filters.category.tempValue.length }}
                  </span>
            </template>
          </v-select>
          <div class="text-right mt-3">

          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setCategoryFilter">Выбрать</v-btn>
          <v-btn
                  outlined
                  @click="filters.category.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="filters.tag.modal"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
                  :items="tags"
                  :item-text="tag => tag.name"
                  :item-value="tag => tag.id"
                  v-model="filters.tag.tempValue"
                  label="Тег"
                  :clearable="true"
                  outlined
                  multiple
                  :hide-details="true"
          >
            <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="font-weight-bold">
                    Выбрано: {{ filters.tag.tempValue.length }}
                  </span>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setTagFilter" >Выбрать</v-btn>

          <v-btn
                  outlined
                  @click="filters.tag.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import ProductService from './../../api/ProductService'
  import CategoryService from './../../api/CategoryService'
  import TagService from './../../api/TagService'

  export default {
    name: 'ProductIndex',
    components: {},
    data: () => ({
      tab: 1,
      massTagDialog: false,
      massSelectedTag: {},
      submitDialog: false,
      submitItem: null,
      selected: [],
      filters: {
        category: {
          value: [],
          tempValue: [],
          modal: false,
        },
        tag: {
          value: [],
          tempValue: [],
          modal: false,
        },
        name: {
          value: '',
          tempValue: '',
          modal: false,
        },
      },
      timerId: null,
      overlay: false,
      search: '',
      loading: true,
      tags: [],
      options: {},
      footerProps: {
        itemsPerPageText: 'Блюд на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [15, 30]
      },
      totalProducts: 0,
      headers: [
        {
          text: 'Блюдо',
          value: 'name',
        },
        {text: 'Категория', value: 'category.name'},
        {
          text: 'Теги',
          value: 'tag',
          sortable: false,
        },
        {
          text: 'Цена',
          value: 'price',
        },
        {
          text: 'Кол-во заказов',
          value: 'order_items_count',
        },
        { value: 'actions', sortable: false, width: "5%"},
      ],
      products: [],
      categories: [],
    }),
    mounted() {
      CategoryService.list().then(response => {
        this.categories = response.data
      });
      TagService.list().then(response => {
        this.tags = response.data
      });
    },
    beforeRouteLeave (to, from, next) {
      let data = {
        tab: this.tab,
        selected: this.selected,
        filters: this.filters,
        options: this.options,
        totalProducts: this.totalProducts,
        products: this.products,
      }
      if(to.name == 'product-create' || to.name == 'product-edit'){
        localStorage.setItem('productIndex', JSON.stringify(data))
      }
      next()
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if(localStorage.getItem('productIndex') && (from.name == 'product-create' || from.name == 'product-edit')){
          let temp = JSON.parse(localStorage.getItem('productIndex'))
          if(temp.tab){
            vm.tab = temp.tab
          }
          if(temp.selected){
            vm.selected = temp.selected
          }
          if(temp.filters){
            console.log(temp.filters)
            vm.filters = temp.filters
          }
          if(temp.options){
            vm.options = temp.options
          }
          if(temp.totalProducts){
            vm.totalProducts = temp.totalProducts
          }
          if(temp.products){
            vm.products = temp.products
          }
        }
      })
    },
    watch: {
      options: {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      tab: function () {
        this.getDataFromApi()
      },
      "filters.category.value": {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      "filters.name.value": {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      "filters.tag.value": {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      search() {
        clearTimeout(this.timerId)
        this.timerId = setTimeout(() => {
          this.getDataFromApi()
        }, 700)

      }
    },
    methods: {
      copy(productId) {
        ProductService.copy(productId).then(product => {
          console.log(product);
          this.$router.push({ name: 'product-edit', params: { id: product.data?.id } })
        }).catch(console.error);
      },
      submitDelete(item = null){
        if(item){
          this.removeProduct(item)
        } else {
          this.massDelete()
        }
      },
      massHide(){
        let params = {
          ids: this.collectSelectedId()
        };

        ProductService.massEdit('hide', params).then(response => {
          this.getDataFromApi()
        })
      },
      massActive(){
        let params = {
          ids: this.collectSelectedId()
        };

        ProductService.massEdit('active', params).then(response => {
          this.getDataFromApi()
        })
      },
      massTag(){
        let params = {
          ids: this.collectSelectedId(),
          tagId: this.massSelectedTag
        };

        ProductService.massEdit('tag', params).then(response => {
          this.getDataFromApi()
        })
      },
      massDelete(){
        let params = {
          ids: this.collectSelectedId()
        };

        ProductService.massEdit('delete', params).then(response => {
          this.getDataFromApi()
        })
      },
      collectSelectedId(){
        let ids = [];
        this.selected.forEach(function (item) {
          ids.push(item.id)
        })

        return ids;
      },
      removeProduct(item){
        this.loading = true;
          ProductService.remove(item.id).then(response => {
            this.getDataFromApi()
          })
      },
      getItemClass(item){
        if(item.hide == 1){
          return 'hidden-product'
        }
      },
      removeCategory(id){
        this.filters.category.tempValue.splice(this.filters.category.tempValue.indexOf(this.filters.category.tempValue.find(category => category.id == id)) - 1, 1);
        this.setCategoryFilter()

      },
      removeTag(id){
        this.filters.tag.tempValue.splice(this.filters.tag.tempValue.indexOf(this.filters.tag.tempValue.find(tag => tag.id == id)) - 1, 1);
        this.setTagFilter()

      },
      getCategoryNameById(id){
        return this.categories.find(category => category.id == id).name;
      },
      getTagNameById(id){
        return this.tags.find(tag => tag.id == id).name;
      },
      setCategoryFilter(e) {
        this.filters.category.value = this.filters.category.tempValue
        this.filters.category.modal = false;
        this.overlay = false;
      },
      setNameFilter(e) {
        this.filters.name.value = this.filters.name.tempValue
        this.filters.name.modal = false;
        this.overlay = false;
      },
      setTagFilter(e) {
        this.filters.tag.value = this.filters.tag.tempValue
        this.filters.tag.modal = false;
        this.overlay = false;
      },
      getDataFromApi() {
        this.loading = true
        this.selected = [];
        let params = {
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
          sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
          search: this.search,
          categories: this.filters.category.value,
          tags: this.filters.tag.value,
          name: this.filters.name.value,
          type: this.tab,
          withChildren: true,
        }
        ProductService.list(params)
          .then(response => {
            this.products = response.data.data
            this.totalProducts = response.data.total
            this.loading = false
          })
      },
    }
  }
</script>

<style lang="scss">
  table{
    tr{
      &.hidden-product{
        background-color: #FFEEEC;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
